//write code for leads
import { getLeads } from "./services";
// Action Types
export const GET_LEADS_REQUEST = "GET_LEADS_REQUEST";
export const GET_LEADS_SUCCESS = "GET_LEADS_SUCCESS";
export const GET_LEADS_FAILURE = "GET_LEADS_FAILURE";
// Action Creators
export const getLeadsRequest = () => {
    return {
        type: GET_LEADS_REQUEST,
    };
}

export const getLeadsSuccess = (leads) => {
    return {
        type: GET_LEADS_SUCCESS,
        payload: leads,
    };
}

export const getLeadsFailure = (error) => {
    return {
        type: GET_LEADS_FAILURE,
        payload: error,
    };
}

export const getLeadsAction = () => async (dispatch) => {
    try {
        dispatch(getLeadsRequest());
        const response = await getLeads();
        dispatch(getLeadsSuccess(response.data));
    } catch (error) {
        console.log(error);
        dispatch(getLeadsFailure(error.message));
    }
}